// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5355 2.80732C17.0976 1.24522 19.6303 1.24522 21.1924 2.80732C22.7545 4.36941 22.7545 6.90207 21.1924 8.46417L18.3638 11.2928L18.7175 11.6465C19.108 12.037 19.108 12.6702 18.7175 13.0607C18.327 13.4512 17.6938 13.4512 17.3033 13.0607L16.9498 12.7072L10.7351 18.9219C10.1767 19.4803 9.46547 19.8609 8.6911 20.0158L6.93694 20.3666C6.54976 20.4441 6.19416 20.6344 5.91496 20.9136L4.92894 21.8996C4.53841 22.2901 3.90525 22.2901 3.51472 21.8996L2.10051 20.4854C1.70999 20.0949 1.70999 19.4617 2.10051 19.0712L3.08653 18.0851C3.36574 17.8059 3.55605 17.4503 3.63348 17.0632L3.98431 15.309C4.13919 14.5346 4.51981 13.8234 5.07821 13.265L11.2929 7.05033L10.9393 6.69674C10.5488 6.30622 10.5488 5.67305 10.9393 5.28253C11.3299 4.892 11.963 4.892 12.3535 5.28253L12.7069 5.63592L15.5355 2.80732ZM12.7071 8.46454L6.49242 14.6793C6.21322 14.9585 6.02291 15.3141 5.94548 15.7012L5.59464 17.4554C5.43977 18.2298 5.05915 18.941 4.50075 19.4994C5.05915 18.941 5.77035 18.5603 6.54471 18.4055L8.29887 18.0546C8.68605 17.9772 9.04165 17.7869 9.32085 17.5077L15.5355 11.293L12.7071 8.46454Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
